/**
 * Parcels Details
 */

// React
import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';

// Context
import AuthContext from '../../authContext';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Dialog,
  Typography,
  DialogActions,
  Paper,
  Grid,
  Button,
  Divider,
  CircularProgress,
  Select,
  FormControl,
  IconButton,
  MenuItem,
  DialogTitle,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiStateMachine,
  mdiKeyOutline,
  mdiAccountOutline,
  mdiWarehouse,
  mdiArrowRight,
  mdiFormatListCheckbox,
  mdiPackage,
  mdiPhoneOutline,
  mdiCalendar,
  mdiCalendarClock,
  mdiMapMarkerOutline,
  mdiPrinter,
  mdiClose,
  mdiCheck,
  mdiAccount,
} from '@mdi/js';

// Components
import ListParcelItems from './list';

// Helper
import {
  translate,
  formaterPhoneNumber,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { Status } from '../orders/interfaces';
import { Props } from './interfaces';
import Pagination from '@material-ui/lab/Pagination';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotification';
import parcelRepository from 'client-sdk/src/Repository/parcels-repository';
import warehouseRepository from 'client-sdk/src/Repository/warehouses-repository';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    allocateIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    showCount: {
      '& .MuiSelect-icon': {
        color: '#DFA01F',
      },
    },
  })
);

export function Details(props: Props) {
  const authContext = useContext(AuthContext);
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [openDialog, setOpenDialog] = useState(false as boolean);
  const [statusChanged, setStatusChanged] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 10,
  } as any);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );

  const [parcel, setParcel] = useState({});
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [usersCount, setUsersCount] = useState(0);
  const [usersLoading, setUsersLoading] = useState(false);
  const [error, setError] = useState('');

  const classes = useStyles();

  const handleCloseAllocate = () => {
    setOpenDialog(false);
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleOpenConfirmDisable = (id: number) => {
    setOpenDialog(true);
    setId(id);
  };
  const updateParcelsAllocateOperator = async (actions: any) => {
    const payload = { ...actions };
    try {
      setLoading(true);
      const callback = await parcelRepository.updateParcelOperator({ payload });
      handleNotfication('محموله با موفقیت تخصیص داده شد', 'success');
      callback && callback();
    } catch (error) {
      setError(error.message);
      handleNotfication('تخصیص محموله با خطا مواجه شد', 'error');
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const handleAllocateUser = () => {
    updateParcelsAllocateOperator({
      id: parcel.id,
      body: id,
      ...filtersValues,
      callback: () => {
        setStatusChanged(!statusChanged);
      },
    });
    setOpenDialog(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };
  const getParcelWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const response = await parcelRepository.getParcelsWithId({ payload });
      setParcel(response.data);
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const getUsers = async (actions: any) => {
    const payload = { ...actions };
    try {
      setUsersLoading(true);
      const response = await warehouseRepository.getWarehouseOperatorsById({
        payload,
      });
      setUsers(response.data.content);
      setUsersCount(response.data.totalElements);
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setUsersLoading(false);
    }
  };
  useEffect(() => {
    const { page, size } = filtersValues;
    const { id, warehouseId } = props.match.params;
    getParcelWithId(id);
    getUsers({ id: { equals: warehouseId }, page, size });
  }, [statusChanged]); // eslint-disable-line react-hooks/exhaustive-deps

  const changeStatusOrder = () => {
    const { id } = props.match.params;

    handleClose();
  };

  const handleOpenConfirmUpdateState = (body: Status) => {
    setOpenConfirmUpdateState(true);
    setPreviewState(body);
  };

  const handleClose = () => {
    setOpenConfirmUpdateState(false);
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        جزيیات محموله 
        ${parcel.destinationName}

     
        `}
        </Typography>
        <span className={classes.contentlabelTitle}>{parcel.id}</span>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {`بازگشت`}
        </Button>

        <Link
          to={`/parcels/receipts/${parcel.id}`}
          target="_blank"
          style={{ textDecoration: 'none' }}
        >
          <Button
            variant="contained"
            color="secondary"
            startIcon={<Icon path={mdiPrinter} size={1} />}
          >{`چاپ حواله`}</Button>
        </Link>
      </Grid>
      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiWarehouse} size={1} className={classes.icon} />
                {`انبار مقصد:  `}
              </span>

              <span>{parcel.destinationName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiKeyOutline} size={1} className={classes.icon} />
                {`شناسه محموله:  `}
              </span>

              <span>{parcel.id}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiFormatListCheckbox}
                  size={1}
                  className={classes.icon}
                />
                {`نوع ارسال:  `}
              </span>
              <span>{translate(parcel.deliveryType)}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiPackage} size={1} className={classes.icon} />
                {`تعداد آیتم:  `}
              </span>

              <span>{parcel?.items?.length}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiAccountOutline}
                  size={1}
                  className={classes.icon}
                />
                {`نام مسئول حمل:  `}
              </span>

              <span>{parcel.agentName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiPhoneOutline}
                  size={1}
                  className={classes.icon}
                />
                {`شماره همراه مسئول حمل:  `}
              </span>
              <span>{formaterPhoneNumber(parcel.agentPhoneNumber)}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {`تاریخ ثبت محموله:  `}
              </span>
              <span>
                <span>
                  {parcel.deliveryDate &&
                    `${jMoment(parcel.shippingDate, 'YYYY/MM/DD')
                      .locale('fa')
                      .format('jYYYY/jMM/jDD')}`}
                </span>
              </span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCalendar} size={1} className={classes.icon} />
                {`تاریخ تحویل به انبار:  `}
              </span>
              <span>
                <span>
                  {parcel.shippingDate &&
                    `${jMoment(parcel.deliveryDate, 'YYYY/MM/DD')
                      .locale('fa')
                      .format('jYYYY/jMM/jDD')}`}
                </span>
              </span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiCalendarClock}
                  size={1}
                  className={classes.icon}
                />
                {`بازه تحویل محموله:  `}
              </span>
              <span>
                <span>
                  {parcel.deliveryStartTime &&
                    jMoment(parcel.deliveryStartTime, 'hh:mm')
                      .locale('fa')
                      .format('HH:mm')}
                  {` - `}
                  {parcel.deliveryEndTime &&
                    jMoment(parcel.deliveryEndTime, 'hh:mm')
                      .locale('fa')
                      .format('HH:mm')}
                </span>
              </span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiStateMachine}
                  size={1}
                  className={classes.icon}
                />
                {`وضعیت تحویل :  `}
              </span>
              <span>{translate(parcel.status)}</span>
            </div>
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.icon}
                />
                {`آدرس انبار مقصد :  `}
              </span>
              <span>{parcel.destinationAddress}</span>
            </div>
          </Grid>
        </Grid>
      </Paper>
      <Paper className={classes.paper}>
        <div style={{ padding: '0 10px 20px 10px' }}>
          اپراتور تخصیص داده شده :{' '}
        </div>
        <Grid container xs={12}>
          <Grid xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiKeyOutline} size={1} className={classes.icon} />
                {`شناسه اپراتور :  `}
              </span>
              <span>{parcel.operatorId}</span>
            </div>
          </Grid>

          <Grid xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiAccountOutline}
                  size={1}
                  className={classes.icon}
                />
                {`نام اپراتور :  `}
              </span>
              <span>{parcel.operatorName}</span>
            </div>
          </Grid>
          <Grid xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiAccount} size={1} className={classes.icon} />
                {`نقش اپراتور :  `}
              </span>
              <span>{translate(parcel.operatorRole, 'user')}</span>
            </div>
          </Grid>
        </Grid>
      </Paper>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {usersLoading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            users && (
              <ListParcelItems
                operatorId={parcel.operatorId}
                handleOpenConfirmDisable={handleOpenConfirmDisable}
                data={users}
              />
            )
          )}
        </Grid>
        <Grid id="showFilter" item xs={12} sm={6}>
          {users && (
            <FormControl
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                {' '}
                تعداد نمایش در هر صفحه:
              </div>
              <Select
                open={openSize}
                onClose={handleCloseSelect}
                className={classes.showCount}
                onOpen={() => setOpenSize(true)}
                value={filtersValues.size}
                onChange={handleChangeSizePage}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          )}
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          {users && (
            <Pagination
              count={Math.ceil(usersCount / filtersValues.size)}
              color="secondary"
              page={filtersValues.page + 1}
              onChange={handleChangePage}
            />
          )}
        </Grid>
      </Grid>
      <Dialog
        fullWidth
        open={openDialog}
        onClose={handleCloseAllocate}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseAllocate ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseAllocate}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.allocateIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {` از
            تخصیص این محموله
            به اپراتور با شناسه
          "${users.find(item => item.id === id)?.id}"
          مطمئن هستید؟`}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions>
          <Grid container spacing={1} justifyContent="flex-end">
            <Grid item xs={2}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseAllocate}
                variant="outlined"
                size="large"
              >
                {`انصراف`}
              </Button>
            </Grid>

            <Grid item xs={5}>
              <Button
                onClick={handleAllocateUser}
                fullWidth
                variant="contained"
                color="primary"
                size="large"
              >
                {`تخصیص اپراتور`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}

// const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
//   parcel: makeSelectParcel(),
//   users: makeSelectWarehouseOperatorsList(),
//   usersCount: makeSelectWarehouseOperatorsCount(),
//   loading: makeSelectLoading(),
//   usersLoading: makeSelectUsersLoading(),
//   error: makeSelectError(),
// });

// function mapDispatchToProps(dispatch: Function) {
//   return {
//     getParcelWithIdActionDispatch: (id: number) =>
//       dispatch(getParcelsWithIdAction({id})),
//     getUsersActionDispatch: (payload: Object) => dispatch(getWarehouseOperatorsActions(payload)),
//     updateParcelsAllocateOperatorDispatch: (payload: Object) => dispatch(updateParcelOperatorActions(payload))
//   };
// }

// const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default Details;
